import React from "react";
import { MetaTags } from "react-meta-tags";
//import Breadcrumbs
import {
    Breadcrumbs,
    DashBreadcrumb,
  } from "../../../../components/Common/Breadcrumb";
import ReturnMarketplaceList from "./../../components/ReturnMarketplaceList"; 
import "react-datepicker/dist/react-datepicker.css"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import ReturnMktExportReport from '../../../Returns/components/ReturnMktExportReport';
import { EXPORT_ALLOWED_USER_ROLES } from '../../../../constants';

import {
    Col,
    Container,
    Row,
    FormGroup, 
    InputGroup, 
  } from "reactstrap";

const ReturnMarketplace = () => {
  const title = "Orders";
  const description = "Manage Marketplace Return Orders";
    const users = JSON.parse(localStorage?.getItem('authUser'));

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Mange Marketplace Return Orders</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="Orders" breadcrumbItem="Manage Marketplace Return Orders" />
            </Col>
             <Col>
              {EXPORT_ALLOWED_USER_ROLES.includes(users?.role_id) ? (
                <ReturnMktExportReport users={users} />
              ) : (
                ''
              )}
            </Col>
          </Row>
          
            <ReturnMarketplaceList /> 
         
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReturnMarketplace;
